import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('qposm_token');
    const savedUser = localStorage.getItem('qposm_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem('qposm_token');
        localStorage.removeItem('qposm_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password, captchaId, captchaAnswer) => {
    const response = await api.post('/auth/login', {
      username,
      password,
      captchaId,
      captchaAnswer,
    });

    if (response.data.success) {
      const { token, user: userData } = response.data;
      localStorage.setItem('qposm_token', token);
      localStorage.setItem('qposm_user', JSON.stringify(userData));
      setUser(userData);
      return { success: true, mustChangePassword: userData.mustChangePassword, user: userData };
    }
    return { success: false, message: response.data.message };
  };

  const updateUserAfterPasswordChange = (token, userData) => {
    localStorage.setItem('qposm_token', token);
    localStorage.setItem('qposm_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('qposm_token');
    localStorage.removeItem('qposm_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUserAfterPasswordChange }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
